/**
 * Centralized public contact configuration for AIMaker Studio.
 * Production mailboxes on aimakerstudio.net.
 */
export const SITE_CONTACT = {
  hello: process.env.NEXT_PUBLIC_HELLO_EMAIL ?? 'hello@aimakerstudio.net',
  support: process.env.NEXT_PUBLIC_SUPPORT_EMAIL ?? 'support@aimakerstudio.net',
  billing: process.env.NEXT_PUBLIC_BILLING_EMAIL ?? 'billing@aimakerstudio.net',
  security: process.env.NEXT_PUBLIC_SECURITY_EMAIL ?? 'security@aimakerstudio.net',
  /** Legal, copyright, and DMCA inquiries — dedicated legal mailbox. */
  legal: process.env.NEXT_PUBLIC_LEGAL_EMAIL ?? 'legal@aimakerstudio.net',
  /** Trust & safety reports — no dedicated mailbox; routes to support. */
  safety: process.env.NEXT_PUBLIC_SAFETY_EMAIL ?? 'support@aimakerstudio.net',
  /** Account appeals — no dedicated mailbox; routes to support. */
  appeals: process.env.NEXT_PUBLIC_APPEALS_EMAIL ?? 'support@aimakerstudio.net',
  companyName: 'BeMel Productions LLC',
  platformName: 'AIMaker Studio',
  jurisdiction: 'Georgia, United States',
  effectiveDate: 'June 20, 2026',
} as const;

export type SiteContactKey = keyof typeof SITE_CONTACT;

/** Replace {supportEmail}, {securityEmail}, etc. in localized legal template strings. */
export function interpolateSiteContact(text: string): string {
  return text
    .replace(/\{helloEmail\}/g, SITE_CONTACT.hello)
    .replace(/\{supportEmail\}/g, SITE_CONTACT.support)
    .replace(/\{billingEmail\}/g, SITE_CONTACT.billing)
    .replace(/\{securityEmail\}/g, SITE_CONTACT.security)
    .replace(/\{legalEmail\}/g, SITE_CONTACT.legal)
    .replace(/\{safetyEmail\}/g, SITE_CONTACT.safety)
    .replace(/\{appealsEmail\}/g, SITE_CONTACT.appeals)
    .replace(/\{companyName\}/g, SITE_CONTACT.companyName)
    .replace(/\{platformName\}/g, SITE_CONTACT.platformName)
    .replace(/\{jurisdiction\}/g, SITE_CONTACT.jurisdiction);
}
